import { type Component, For, Show } from 'solid-js'
import { A } from '@solidjs/router'

export interface BreadcrumbSegment {
  /** Display label — or an i18n key if prefixed with `ls_` */
  readonly label: string
  /** If set, the segment is a clickable link */
  readonly href?: string
}

interface BreadcrumbsProps {
  readonly segments: BreadcrumbSegment[]
}

const Breadcrumbs: Component<BreadcrumbsProps> = (props) => {
  return (
    <nav class="flex items-center gap-2" aria-label="Breadcrumb">
      <For each={props.segments}>
        {(segment, index) => {
          const isLast = () => index() === props.segments.length - 1
          return (
            <>
              <Show when={index() > 0}>
                <span class="text-gray-300 text-xl font-light select-none" aria-hidden>
                  ›
                </span>
              </Show>
              <Show
                when={segment.href && !isLast()}
                fallback={
                  <h1
                    class="text-xl font-medium transition-colors duration-150"
                    classList={{
                      'text-gray-700': isLast(),
                      'text-gray-400': !isLast()
                    }}
                  >
                    {segment.label}
                  </h1>
                }
              >
                <A
                  href={segment.href!}
                  class="text-xl font-medium text-gray-500 hover:text-primary-800 transition-colors duration-150"
                >
                  {segment.label}
                </A>
              </Show>
            </>
          )
        }}
      </For>
    </nav>
  )
}

export default Breadcrumbs
